import { IFilter } from '../../types/filters';
import { FloorsContainer } from '../../containers/advancedFilters/FloorsContainer';

export const floors: IFilter = {
  component: FloorsContainer,
};
